<div class="modal-body">
  <app-callcard-info-card [callcard]="card"></app-callcard-info-card>
  <app-callcard-cevents-card [callcard]="card"></app-callcard-cevents-card>
  <app-callcard-clocations-card [callcard]="card" [enableInteraction]="false"></app-callcard-clocations-card>
  <app-callcard-cnotes-card [callcard]="card"></app-callcard-cnotes-card>
</div>
